export const FETCH_SHIFTS_REQUEST = 'FETCH_SHIFTS_REQUEST';
export const FETCH_SHIFTS_SUCCESS = 'FETCH_SHIFTS_SUCCESS';
export const FETCH_SHIFTS_FAILURE = 'FETCH_SHIFTS_FAILURE';

export const SET_SCHEDULE_VIEW = 'SET_SCHEDULE_VIEW';
export const SET_SCHEDULE_FILTERS = 'SET_SCHEDULE_FILTERS';
export const SET_SELECTED_SHIFT = 'SET_SELECTED_SHIFT';
export const CLEAR_SELECTED_SHIFT = 'CLEAR_SELECTED_SHIFT';

export const FETCH_SCHEDULE_DROPDOWNS_REQUEST = 'FETCH_SCHEDULE_DROPDOWNS_REQUEST';
export const FETCH_SCHEDULE_DROPDOWNS_SUCCESS = 'FETCH_SCHEDULE_DROPDOWNS_SUCCESS';
export const FETCH_SCHEDULE_DROPDOWNS_FAILURE = 'FETCH_SCHEDULE_DROPDOWNS_FAILURE';

export const SAVE_SHIFT_REQUEST = 'SAVE_SHIFT_REQUEST';
export const SAVE_SHIFT_SUCCESS = 'SAVE_SHIFT_SUCCESS';
export const SAVE_SHIFT_FAILURE = 'SAVE_SHIFT_FAILURE';

export const SAVE_SHIFT_BULK_REQUEST = 'SAVE_SHIFT_BULK_REQUEST';
export const SAVE_SHIFT_BULK_SUCCESS = 'SAVE_SHIFT_BULK_SUCCESS';
export const SAVE_SHIFT_BULK_FAILURE = 'SAVE_SHIFT_BULK_FAILURE';
export const CLEAR_BULK_RESULT = 'CLEAR_BULK_RESULT';

export const DELETE_SHIFT_REQUEST = 'DELETE_SHIFT_REQUEST';
export const DELETE_SHIFT_SUCCESS = 'DELETE_SHIFT_SUCCESS';
export const DELETE_SHIFT_FAILURE = 'DELETE_SHIFT_FAILURE';

export const UPDATE_SHIFT_GROUP_REQUEST = 'UPDATE_SHIFT_GROUP_REQUEST';
export const UPDATE_SHIFT_GROUP_SUCCESS = 'UPDATE_SHIFT_GROUP_SUCCESS';
export const UPDATE_SHIFT_GROUP_FAILURE = 'UPDATE_SHIFT_GROUP_FAILURE';

export const SWAP_SHIFT_REQUEST = 'SWAP_SHIFT_REQUEST';
export const SWAP_SHIFT_SUCCESS = 'SWAP_SHIFT_SUCCESS';
export const SWAP_SHIFT_FAILURE = 'SWAP_SHIFT_FAILURE';

export const SWAP_SHIFT_GROUP_REQUEST = 'SWAP_SHIFT_GROUP_REQUEST';
export const SWAP_SHIFT_GROUP_SUCCESS = 'SWAP_SHIFT_GROUP_SUCCESS';
export const SWAP_SHIFT_GROUP_FAILURE = 'SWAP_SHIFT_GROUP_FAILURE';

export const SET_CONFLICT_PREVIEW = 'SET_CONFLICT_PREVIEW';
export const CLEAR_CONFLICT_PREVIEW = 'CLEAR_CONFLICT_PREVIEW';

export const DELETE_SHIFT_GROUP_REQUEST = 'DELETE_SHIFT_GROUP_REQUEST';
export const DELETE_SHIFT_GROUP_SUCCESS = 'DELETE_SHIFT_GROUP_SUCCESS';
export const DELETE_SHIFT_GROUP_FAILURE = 'DELETE_SHIFT_GROUP_FAILURE';

export const UPDATE_SHIFT_NOTES_REQUEST = 'UPDATE_SHIFT_NOTES_REQUEST';
export const UPDATE_SHIFT_NOTES_SUCCESS = 'UPDATE_SHIFT_NOTES_SUCCESS';
export const UPDATE_SHIFT_NOTES_FAILURE = 'UPDATE_SHIFT_NOTES_FAILURE';

export const FETCH_SHIFT_PRIVILEGES_REQUEST = 'FETCH_SHIFT_PRIVILEGES_REQUEST';
export const FETCH_SHIFT_PRIVILEGES_SUCCESS = 'FETCH_SHIFT_PRIVILEGES_SUCCESS';
export const FETCH_SHIFT_PRIVILEGES_FAILURE = 'FETCH_SHIFT_PRIVILEGES_FAILURE';

export const FETCH_RAD_ASSOCIATED_SITES_REQUEST = 'FETCH_RAD_ASSOCIATED_SITES_REQUEST';
export const FETCH_RAD_ASSOCIATED_SITES_SUCCESS = 'FETCH_RAD_ASSOCIATED_SITES_SUCCESS';
export const FETCH_RAD_ASSOCIATED_SITES_FAILURE = 'FETCH_RAD_ASSOCIATED_SITES_FAILURE';
export const CLEAR_RAD_ASSOCIATED_SITES = 'CLEAR_RAD_ASSOCIATED_SITES';

export const FETCH_RADS_ASSOCIATED_SITES_REQUEST = 'FETCH_RADS_ASSOCIATED_SITES_REQUEST';
export const FETCH_RADS_ASSOCIATED_SITES_SUCCESS = 'FETCH_RADS_ASSOCIATED_SITES_SUCCESS';
export const FETCH_RADS_ASSOCIATED_SITES_FAILURE = 'FETCH_RADS_ASSOCIATED_SITES_FAILURE';

export const SAVE_TASK_REQUEST = 'SAVE_TASK_REQUEST';
export const SAVE_TASK_SUCCESS = 'SAVE_TASK_SUCCESS';
export const SAVE_TASK_FAILURE = 'SAVE_TASK_FAILURE';

export const FETCH_TASK_DETAIL_REQUEST = 'FETCH_TASK_DETAIL_REQUEST';
export const FETCH_TASK_DETAIL_SUCCESS = 'FETCH_TASK_DETAIL_SUCCESS';
export const FETCH_TASK_DETAIL_FAILURE = 'FETCH_TASK_DETAIL_FAILURE';
export const CLEAR_TASK_DETAIL = 'CLEAR_TASK_DETAIL';
